// GENERATED-STYLE, HAND-REFRESHABLE. Not produced by a build step: there is
// nothing upstream to run. Refresh it by re-running the recipe in this header
// when the 2025 kicking file or the house defense order changes.
//
// Projected 2026 SEASON POINTS for the 32 team defenses and the 32 starting
// kickers, under this project's STANDARD K and DEF scoring
// (DEFAULT_SCORING in src/data/scoring.js).
//
// 🔴 THESE NUMBERS DO NOT MOVE WITH A LEAGUE'S SCORING, AND v1 SAYS SO OUT LOUD.
// Everywhere else on /rate "stats are truth, points are a view" and a lens is
// applied; here the points ARE the artifact. K and DEF scoring varies far more
// between platforms than skill scoring does, and we hold no per-team kicking or
// defensive STAT lines to re-score - only these totals. Applying a user's lens
// to a number derived under a different one would be a made-up figure wearing a
// real one's clothes. The report's face line says "K and DEF use standard
// kicker and defense scoring" for exactly this reason. A user-lens version is a
// later job and needs stat lines first, not a multiplier.
//
// ── HOW THE KICKERS WERE DERIVED ────────────────────────────────────────────
// Source: src/data/stats2025.js (Pro Football Reference 2025 actuals) and
// src/data/liveBoardKickers.json (the 32 starting kickers, one per team).
//   1. Score every 2025 kicking season under DEFAULT_SCORING: 3 points inside
//      40, 4 from 40-49, 5 from 50+, -1 a miss, 1 an extra point, -1 a missed
//      extra point. A row whose distance buckets do not add up to its own fgm
//      scores the remainder flat at 3.
//   2. Keep the real kicking roles: 8+ games and 15+ attempts. STATS_2025
//      files punters under pos "K" with no attempts at all, and a backup who
//      kicked twice in December is not a season. 31 kickers survive, mean
//      8.256 points per game.
//   3. TIER TO 2026 BY REGRESSING HARD TO THAT MEAN: projected ppg =
//      mean + 0.30 x (2025 ppg - mean). Kicker year-over-year correlation is
//      the weakest at any fantasy position, so a projection that carried 2025
//      forward at face value would be a confident restatement of last year's
//      luck. 0.30 keeps the ordering and flattens the spread to something a
//      season can plausibly reproduce.
//   4. A 2026 starter with no qualifying 2025 season - a rookie, or somebody
//      who won a job in camp - projects at the mean exactly. 23 of the 32
//      matched; the other 9 are at 8.256 ppg by construction.
//   5. Season points = projected ppg x 17.
//
// ── HOW THE DEFENSES WERE DERIVED ───────────────────────────────────────────
// 🔴 NOT FROM 2025 ACTUALS, BECAUSE THIS REPO HOLDS NONE. There is no team
// defense stat line anywhere in the tree - not in stats2025.js, not in the
// weekly file, not in either almanac. Rather than invent one, the ladder is
// built from the house's OWN 2026 defense order, which is a real committed
// input: the 32 DEF entries in src/data/players.js, in posRank order DEF1
// (Houston) through DEF32 (Washington).
//   1. Anchor the top at 140 season points. That is this project's own elite
//      defense, STAT_BASELINES.DEF (45 sacks, 16 INT, 10 fumble recoveries,
//      3 TD, 2 safeties, 2 blocked kicks, 19 points allowed per game) scored
//      under DEFAULT_SCORING: 123 from the events, 17 from a season of the
//      14-20 points-allowed tier.
//   2. Anchor the bottom at 65, the same arithmetic on a bottom-of-the-league
//      line: 30 sacks, 8 INT, 6 fumble recoveries, 1 TD, no safeties, no
//      blocked kicks, and 27 points allowed a game, which scores nothing.
//   3. Space the 32 evenly between the two. A real DST ladder is close to
//      linear through the middle and this makes no claim to be sharper than
//      the ordering it is built on: the ORDER is the house's, the LEVEL is
//      these two anchors.
//
// ⚠️ WHAT THIS IS FOR, AND WHAT IT IS NOT FOR. /rate projects a roster's
// lineup, and Ben's note is the whole reason it exists: "the point projections
// are off if you don't." A team that starts a kicker and a defense scores
// points with them, and leaving two lineup slots at zero understated every such
// roster. It is NOT a price input: K and DEF still grade as surplus 0 by
// benchmark rule, and nothing here reaches the auction engine.

export const KD_PROJECTIONS_2026 = {
  ARI: {
    def: { name: "Arizona Cardinals", points: 89.2, games: 17 },
    k: { name: "Chad Ryland", points: 134.8, games: 17 },
  },
  ATL: {
    def: { name: "Atlanta Falcons", points: 101.3, games: 17 },
    k: { name: "Nick Folk", points: 138.4, games: 17 },
  },
  BAL: {
    def: { name: "Baltimore Ravens", points: 103.7, games: 17 },
    k: { name: "Tyler Loop", points: 139.6, games: 17 },
  },
  BUF: {
    def: { name: "Buffalo Bills", points: 106.1, games: 17 },
    k: { name: "Tyler Bass", points: 140.4, games: 17 },
  },
  CAR: {
    def: { name: "Carolina Panthers", points: 86.8, games: 17 },
    k: { name: "Ryan Fitzgerald", points: 129.1, games: 17 },
  },
  CHI: {
    def: { name: "Chicago Bears", points: 84.4, games: 17 },
    k: { name: "Cairo Santos", points: 141.4, games: 17 },
  },
  CIN: {
    def: { name: "Cincinnati Bengals", points: 81.9, games: 17 },
    k: { name: "Evan McPherson", points: 137.2, games: 17 },
  },
  CLE: {
    def: { name: "Cleveland Browns", points: 113.4, games: 17 },
    k: { name: "Andre Szmyt", points: 130.6, games: 17 },
  },
  DAL: {
    def: { name: "Dallas Cowboys", points: 79.5, games: 17 },
    k: { name: "Brandon Aubrey", points: 152.2, games: 17 },
  },
  DEN: {
    def: { name: "Denver Broncos", points: 137.6, games: 17 },
    k: { name: "Wil Lutz", points: 137.2, games: 17 },
  },
  DET: {
    def: { name: "Detroit Lions", points: 111, games: 17 },
    k: { name: "Jake Bates", points: 141.1, games: 17 },
  },
  GB: {
    def: { name: "Green Bay Packers", points: 118.2, games: 17 },
    k: { name: "Trey Smack", points: 140.4, games: 17 },
  },
  HOU: {
    def: { name: "Houston Texans", points: 140, games: 17 },
    k: { name: "Ka'imi Fairbairn", points: 162.8, games: 17 },
  },
  IND: {
    def: { name: "Indianapolis Colts", points: 96.5, games: 17 },
    k: { name: "Blake Grupe", points: 136.8, games: 17 },
  },
  JAC: {
    def: { name: "Jacksonville Jaguars", points: 123.1, games: 17 },
    k: { name: "Cam Little", points: 145.9, games: 17 },
  },
  KC: {
    def: { name: "Kansas City Chiefs", points: 108.5, games: 17 },
    k: { name: "Harrison Butker", points: 140.2, games: 17 },
  },
  LAC: {
    def: { name: "Los Angeles Chargers", points: 120.6, games: 17 },
    k: { name: "Cameron Dicker", points: 148, games: 17 },
  },
  LAR: {
    def: { name: "Los Angeles Rams", points: 132.7, games: 17 },
    k: { name: "Harrison Mevis", points: 140.4, games: 17 },
  },
  LV: {
    def: { name: "Las Vegas Raiders", points: 72.3, games: 17 },
    k: { name: "Matt Gay", points: 134.4, games: 17 },
  },
  MIA: {
    def: { name: "Miami Dolphins", points: 91.6, games: 17 },
    k: { name: "Riley Patterson", points: 136.9, games: 17 },
  },
  MIN: {
    def: { name: "Minnesota Vikings", points: 127.9, games: 17 },
    k: { name: "Will Reichard", points: 145.3, games: 17 },
  },
  NE: {
    def: { name: "New England Patriots", points: 125.5, games: 17 },
    k: { name: "Andy Borregales", points: 140.4, games: 17 },
  },
  NO: {
    def: { name: "New Orleans Saints", points: 98.9, games: 17 },
    k: { name: "Charlie Smyth", points: 140.4, games: 17 },
  },
  NYG: {
    def: { name: "New York Giants", points: 77.1, games: 17 },
    k: { name: "Ben Sauls", points: 140.4, games: 17 },
  },
  NYJ: {
    def: { name: "New York Jets", points: 74.7, games: 17 },
    k: { name: "Jason Sanders", points: 140.4, games: 17 },
  },
  PHI: {
    def: { name: "Philadelphia Eagles", points: 130.3, games: 17 },
    k: { name: "Jake Elliott", points: 130.6, games: 17 },
  },
  PIT: {
    def: { name: "Pittsburgh Steelers", points: 115.8, games: 17 },
    k: { name: "Chris Boswell", points: 141.7, games: 17 },
  },
  SEA: {
    def: { name: "Seattle Seahawks", points: 135.2, games: 17 },
    k: { name: "Jason Myers", points: 156.7, games: 17 },
  },
  SF: {
    def: { name: "San Francisco 49ers", points: 94, games: 17 },
    k: { name: "Eddy Pineiro", points: 140.4, games: 17 },
  },
  TB: {
    def: { name: "Tampa Bay Buccaneers", points: 69.8, games: 17 },
    k: { name: "Chase McLaughlin", points: 142.9, games: 17 },
  },
  TEN: {
    def: { name: "Tennessee Titans", points: 67.4, games: 17 },
    k: { name: "Joey Slye", points: 138.7, games: 17 },
  },
  WAS: {
    def: { name: "Washington Commanders", points: 65, games: 17 },
    k: { name: "Drew Stevens", points: 140.4, games: 17 },
  },
};

export default KD_PROJECTIONS_2026;
